import React, { useState } from "react";
import CustomerInfoEditModal from "./ticketListInfo/CustomerInfoEditModal";
import ReactModal from "react-modal";
import { useCustomerQuery } from "../../Services/settingsAPIs/CommonAPI";
import AccountInfoEditModal from "./ticketListInfo/AccountInfoEditModal";
import "../../pages/contact/styles.scss";
import { useTelephony } from "../context/TelephonyContext";
import { CIRCLEONE_USER, TELEPHONY_LOGIN } from "../../constants";
import parsePhoneNumber, { CountryCode } from "libphonenumber-js";
import axios from "axios";
import { toast } from "react-toastify";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import "./TicketLeftSideMenuCard.scss";

function getLocalPhoneNumber(phoneNumber: string, country: string): string {
  try {
    const parsed = parsePhoneNumber(
      phoneNumber,
      country.toUpperCase() as CountryCode
    );
    return parsed ? parsed.nationalNumber : phoneNumber;
  } catch {
    return phoneNumber;
  }
}

interface IProps {
  tickets: any;
}

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "550px",
    margin: "auto",
    OverflowY: "auto",
    maxHeight: "600px",
  },
};

const TicketLeftSideMenuCard: React.FC<IProps> = ({ tickets }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
  const [showContact, setShowContact] = useState(true);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [pendingPhoneNumber, setPendingPhoneNumber] = useState<string | null>(
    null
  );

  const { data: updateCustomer, refetch } = useCustomerQuery(
    tickets?.action?.contact?.id,
    { skip: !tickets?.action?.contact?.id }
  );

  const { setLifitinMobileNumber } = useTelephony();

  const handleToggle = () => {
    setShowContact(!showContact);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openAccountModal = () => {
    setIsAccountModalOpen(true);
  };

  const closeAccountModal = () => {
    setIsAccountModalOpen(false);
  };

  const gettingTelephonyStatus = localStorage.getItem(TELEPHONY_LOGIN);
  const tenantName = localStorage.getItem(CIRCLEONE_USER);
  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;

  const clickToDial = async (phoneNumber: string) => {
    const czToken = localStorage.getItem("cz_token");
    const AgentEmail = localStorage.getItem("circleone-username");

    if (!czToken) {
      console.warn("CZ token not found in localStorage.");
      return;
    }

    const payload = {
      transaction_id: "CTI_DIAL",
      "x-access-token": czToken,
      agent_id: AgentEmail,
      phone_num: phoneNumber,
      resFormat: "3",
    };

    try {
      const response = await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/telephony/click-to-call/`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const res = response.data?.response;

      if (
        res?.status === "FAILURE" &&
        res?.reason === "Agent is not logged in/not available"
      ) {
        toast.error("Please log in through the iframe to proceed.");
        return;
      }

      console.log("ClickToDial response:", response.data);
    } catch (error) {
      console.error("ClickToDial error:", error);
    }
  };

  const handlePhoneClick = () => {
    const formattedNumber = getLocalPhoneNumber(
      updateCustomer?.phone_number,
      updateCustomer?.country || "IN"
    );
    const isTelephonyLoggedIn =
      String(gettingTelephonyStatus).toLowerCase() === "true";
    const isCloudTelephony =
      tenantName?.trim().toLowerCase() === "cloudtelephony";

    if (isCloudTelephony) {
      if (isTelephonyLoggedIn) {
        setPendingPhoneNumber(formattedNumber);
        setIsConfirmModalOpen(true);
      } else {
        return;
      }
    } else {
      if (isTelephonyLoggedIn) {
        setLifitinMobileNumber(formattedNumber);
      } else {
        return;
      }
    }
  };

  return (
    <div className="customer-info-card">
      <div className="info-header">
        <div className="header-content">
          <span className="header-title">
            {showContact ? "Customer informations" : "Account informations"}
          </span>
          {(showContact || tickets?.action?.contact?.account !== null) && (
            <button
              className="edit-btn"
              onClick={showContact ? openModal : openAccountModal}
            >
              <EditIcon fontSize="small" />
            </button>
          )}
        </div>
      </div>

      <ReactModal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Edit Customer Information"
        shouldCloseOnOverlayClick={false}
      >
        <CustomerInfoEditModal
          data={updateCustomer}
          closeModal={closeModal}
          refetch={refetch}
        />
      </ReactModal>

      <ReactModal
        isOpen={isAccountModalOpen}
        onRequestClose={closeAccountModal}
        style={customModalStyles}
        contentLabel="Edit Account Information"
        shouldCloseOnOverlayClick={false}
      >
        <AccountInfoEditModal
          data={tickets?.action?.contact}
          closeModal={closeAccountModal}
          refetch={refetch}
        />
      </ReactModal>

      <div className="switch-container">
        <span className="switch-label">Account</span>
        <Switch
          checked={showContact}
          onChange={handleToggle}
          size="small"
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": {
              color: "#6366f1",
            },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "#6366f1",
            },
          }}
        />
        <span className="switch-label">Contact</span>
      </div>

      {showContact ? (
        <>
          <div className="info-item">
            <PersonIcon className="info-icon" />
            <span className="info-label">Full name</span>
            <div className="info-value" title={updateCustomer?.name}>
              {updateCustomer?.name}
            </div>
          </div>

          <div className="info-item">
            <EmailIcon className="info-icon" />
            <span className="info-label">Email</span>
            <div className="info-value" title={updateCustomer?.email}>
              {updateCustomer?.email}
            </div>
          </div>

          <div className="info-item">
            <PhoneIcon className="info-icon" />
            <span className="info-label">Phone</span>
            <span
              className="info-value-link"
              title={
                gettingTelephonyStatus === "true"
                  ? "Click to dial"
                  : "Login telephony to call"
              }
              onClick={handlePhoneClick}
            >
              {updateCustomer?.phone_number}
            </span>
          </div>

          <div className="info-item">
            <WhatsAppIcon className="info-icon whatsapp" />
            <span className="info-label">Whatsapp</span>
            <span className="info-value">
              {updateCustomer?.whatsapp_number
                ? updateCustomer?.whatsapp_number
                : "NA"}
            </span>
          </div>
        </>
      ) : (
        <>
          <div className="info-item">
            <span className="info-label">Business Name</span>
            <div
              className="info-value"
              title={tickets?.action?.contact?.account?.name}
            >
              {tickets?.action?.contact?.account?.name || "NA"}
            </div>
          </div>

          <div className="info-item">
            <span className="info-label">Tags</span>
            <div
              className="info-value"
              title={
                tickets?.action?.contact?.account?.tags?.length > 0
                  ? tickets.action.contact.account.tags
                      .map((tag) => tag.name)
                      .join(", ")
                  : "NA"
              }
            >
              {tickets?.action?.contact?.account?.tags?.length > 0
                ? tickets.action.contact.account.tags
                    .map((tag) => tag.name)
                    .join(", ")
                : "NA"}
            </div>
          </div>

          <div className="info-item">
            <span className="info-label">Team</span>
            <div
              className="info-value"
              title={
                tickets?.action?.contact?.account?.accessible_teams?.length > 0
                  ? tickets.action.contact.account.accessible_teams
                      .map((team) => team.name)
                      .join(", ")
                  : "NA"
              }
            >
              {tickets?.action?.contact?.account?.accessible_teams?.length > 0
                ? tickets.action.contact.account.accessible_teams
                    .map((team) => team.name)
                    .join(", ")
                : "NA"}
            </div>
          </div>
        </>
      )}

      <ReactModal
        isOpen={isConfirmModalOpen}
        onRequestClose={() => setIsConfirmModalOpen(false)}
        style={customModalStyles}
        contentLabel="Confirm Call"
        shouldCloseOnOverlayClick={false}
      >
        <div className="confirm-modal">
          <h5>Do you want to call this number?</h5>
          <div className="modal-actions">
            <button
              className="btn btn-primary"
              onClick={() => {
                if (pendingPhoneNumber) {
                  clickToDial(pendingPhoneNumber);
                }
                setIsConfirmModalOpen(false);
              }}
            >
              Yes
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => setIsConfirmModalOpen(false)}
            >
              No
            </button>
          </div>
        </div>
      </ReactModal>
    </div>
  );
};

export default TicketLeftSideMenuCard;